import { useCallback, useState } from "react";
import { useLocation } from "wouter";

import { useLogoutMutation } from "../services";

export const useLogout = (endSession: () => void) => {
  const [, setLocation] = useLocation();
  const [logout] = useLogoutMutation();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const performLogout = useCallback(async () => {
    try {
      setIsLoggingOut(true);
      await logout().unwrap();
      endSession();
      setLocation("/");
    } catch {
      // Keep the user signed in; errorToastMiddleware raises the toast.
    } finally {
      setIsLoggingOut(false);
    }
  }, [logout, endSession, setLocation]);

  return { performLogout, isLoggingOut };
};
